"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {}
        {[{
        label: "Home",
        href: "/HomePage"
      }, {
        label: "The Forge",
        href: "/TheForgePage"
      }, {
        label: "Our Work",
        href: "/OurWorkPage"
      }, {
        label: "Start a Project",
        href: "/StartAProjectPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-sm text-muted-foreground hover:text-primary transition-colors font-mono">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors font-mono">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  const legalLinks = [{
    label: "Privacy Protocol",
    href: "#"
  }, {
    label: "Service Terms",
    href: "#"
  }, {
    label: "Security Policy",
    href: "#"
  }];
  return <section data-section-id="261749" id="footer" className="bg-background text-foreground border-t border-border pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6 font-default">DEVLUX delivers customized digital solutions for both startups and enterprises.</p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-muted-foreground font-mono">
                <MapPin className="size-4 shrink-0 text-primary" />
                <span>Bucharest, Romania</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground font-mono">
                <Phone className="size-4 shrink-0 text-primary" />
                <span>+40 730 654 636</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground font-mono">
                <Mail className="size-4 shrink-0 text-primary" />
                <span>ianis.burcea@yahoo.com</span>
              </div>
            </div>
          </div>

          {}
          

          {}
          

          {}
          
        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left font-mono">© 2026 DEVLUX. Engineered for excellence.</p>
          <p className="text-sm text-muted-foreground text-center md:text-right font-mono">
            Scalable Architecture. Measurable Results.
          </p>
        </div>
      </div>
    </section>;
}